
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { MesaDataCreateRequired, MesaDataUpdateRequired } from "./MesaData";
import MesaData from "./MesaData";

export default {
  name: "app-restaurante-mesa-form",
  props: {
    url: {
      type: String,
      required: true,
    },
    mesa: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: new MesaData({}),
      ambienteOptions: [{ value: null, text: "Selecione" }],
      statusOptions: [
        { value: "livre", text: "Livre" },
        { value: "ocupada", text: "Ocupada" },
        { value: "reservada", text: "Reservada" },
        { value: "inativa", text: "Inativa" },
      ],
    };
  },
  validations() {
    return {
      form: this.isCreateMode ? MesaDataCreateRequired : MesaDataUpdateRequired,
    };
  },
  watch: {
    mesa: {
      handler(newValue) {
        this.form = new MesaData(newValue || {});
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    routeAmbienteId() {
      return this.$route.query.ambiente_id || this.$route.params.ambienteId;
    },
    isCreateMode() {
      return !this.form.id;
    },
    voltarRoute() {
      if (!this.routeAmbienteId) {
        return { name: "restauranteMesasCadastro" };
      }

      return {
        name: "restauranteAmbientesMesas",
        params: {
          ambienteId: this.routeAmbienteId,
        },
        query: {
          ambiente_nome: this.$route.query.ambiente_nome,
        },
      };
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getAmbientes();
  },
  methods: {
    async getAmbientes() {
      try {
        const { data } = await this.$http.post("/restaurante/ambientes/select");
        this.ambienteOptions = [
          { value: null, text: "Selecione" },
          ...data.map((ambiente) => ({
            value: ambiente.id,
            text: ambiente.nome,
          })),
        ];

        if (this.routeAmbienteId && !this.form.ambiente_id) {
          this.form.ambiente_id = parseInt(this.routeAmbienteId, 10);
        }
      } catch (error) {
        this.$toast.error("Não foi possível carregar os ambientes.");
      }
    },
    setAtivo() {
      this.form.ativo = this.form.ativo == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },
    setSubmitLoading(isLoading) {
      const submitButton = this.$refs["submit_mesa"];

      if (!submitButton) {
        return;
      }

      if (isLoading) {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        return;
      }

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
    },
    getPayload() {
      const payload = { ...this.form };

      payload.capacidade =
        payload.capacidade === "" || payload.capacidade === null
          ? null
          : parseInt(payload.capacidade, 10);

      if (this.isCreateMode) {
        payload.numero_inicial = parseInt(payload.numero_inicial, 10);
        payload.numero_final = parseInt(payload.numero_final, 10);
        delete payload.numero;
      } else {
        delete payload.numero_inicial;
        delete payload.numero_final;
      }

      return payload;
    },
    async onSubmit() {
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        this.setSubmitLoading(true);
        await this.$http.post(this.url, this.getPayload());
        this.$router.push(this.voltarRoute);
      } catch (error) {
        this.setSubmitLoading(false);
      }
    },
  },
};
